import { Component, OnInit } from '@angular/core';
import { convertActionBinding } from '@angular/compiler/src/compiler_util/expression_converter';
import * as $ from "jquery";
import { Router, ActivatedRoute } from '@angular/router';
import { CustomDataService } from 'src/app/services/custom-data.service';
import { MoviesService } from 'src/app/services/movies.service';

@Component({
  selector: 'app-schedule',
  templateUrl: './schedule.component.html',
  styleUrls: ['./schedule.component.css']
})
export class ScheduleComponent implements OnInit {

  day ; month ; year  ; convertD ; convertM 
  myDate    ; urlDay  ; GetDay ; movieArray:any[]
  Day1 ; Day2 ;Day3 ;Day4 ;Day5 ; Day6 
  constructor(private _router:Router , private _activatedroute:ActivatedRoute  , private custom:CustomDataService , private movies:MoviesService) 
  {   
      this._activatedroute.params.subscribe(params => {
      this.urlDay = params['day'];
      this.movieArray = []
      // reset and set based on new parameter this time 
      if(this.urlDay == "Day1")
      {
        this.GetDay = this.custom.Day1 ; 
      }
      else if(this.urlDay == "Day2")
      {
        this.GetDay = this.custom.Day2 ; 
      }
      else if(this.urlDay == "Day3")
      {
        this.GetDay = this.custom.Day3 ; 
      }
      else if(this.urlDay == "Day4")
      {
        this.GetDay = this.custom.Day4 ; 
      }
      else if(this.urlDay == "Day5")
      {
        this.GetDay = this.custom.Day5 ; 
      }
      else if(this.urlDay == "Day6")
      {
        this.GetDay = this.custom.Day6 ; 
      }
   
      });
    
  
  }

  ngOnInit() {


    this._activatedroute.params.subscribe(params => {
      this.urlDay = params['day'];
      this.movieArray = []
      // reset and set based on new parameter this time 
      this.GetDay = []
      if(this.urlDay == "Day1")
      {
        this.GetDay = this.custom.Day1 ; 
      }
      else if(this.urlDay == "Day2")
      {
        this.GetDay = this.custom.Day2 ; 
      }
      else if(this.urlDay == "Day3")
      {
        this.GetDay = this.custom.Day3 ; 
      }
      else if(this.urlDay == "Day4")
      {
        this.GetDay = this.custom.Day4 ; 
      }
      else if(this.urlDay == "Day5")
      {
        this.GetDay = this.custom.Day5 ; 
      }
      else if(this.urlDay == "Day6")
      {
        this.GetDay = this.custom.Day6 ; 
      }
      this.getMovies()
      });
     

    /*****************jquery********************** 
    $(document).ready(function(){

      $("body").on("click",".con-date li",function(){
        $(this).siblings().removeClass("activ"); 
        $(this).addClass("activ")
      })
    });***************************/
    /****************get date********************** */
    this. getDay1()  ; 
    this. getDay2()
    this.getDay3()
    this.getDay4()
    this.getDay5()
    this.getDay6()
    /**************************************** */
    
  }
  getDay1()
  {
    this.myDate  = new Date(); 
    this.day = Number(this.myDate.getDate()) ;
    this.month = Number(this.myDate.getMonth() + 1)
    this.convertD = this.convert(this.day , this.month)[0]
    this.convertM = this.convert(this.day , this.month)[1]
    this.year = this.myDate.getFullYear();
    this.Day1 = this.convertM +" "+ this.convertD + " ,  " + this.year ;
  }
  getDay2()
  {
    this.myDate  = new Date( new Date().getTime() + 24 * 60 * 60 * 1000); 
    this.day = Number(this.myDate.getDate()) ;
    this.month = Number(this.myDate.getMonth() + 1)
    this.convertD = this.convert(this.day , this.month)[0]
    this.convertM = this.convert(this.day , this.month)[1]
    this.year = this.myDate.getFullYear();
    this.Day2 = this.convertM +" "+ this.convertD + " ,  " + this.year ;
  }
  getDay3()
  {
    var today = new Date() 
    this.myDate  = new Date(); 
    this.myDate.setDate(today.getDate()+2)
    this.day = Number(this.myDate.getDate()) ;
    this.month = Number(this.myDate.getMonth() + 1)
    this.convertD = this.convert(this.day , this.month)[0]
    this.convertM = this.convert(this.day , this.month)[1]
    this.year = this.myDate.getFullYear();
    this.Day3 = this.convertM +" "+ this.convertD + " ,  " + this.year ;
  }
  getDay4()
  {
    var today = new Date() 
    this.myDate  = new Date(); 
    this.myDate.setDate(today.getDate()+3)
    this.day = Number(this.myDate.getDate()) ;
    this.month = Number(this.myDate.getMonth() + 1)
    this.convertD = this.convert(this.day , this.month)[0]
    this.convertM = this.convert(this.day , this.month)[1]
    this.year = this.myDate.getFullYear();
    this.Day4 = this.convertM +" "+ this.convertD + " ,  " + this.year ;
  }
  getDay5()
  {
    var today = new Date() 
    this.myDate  = new Date(); 
    this.myDate.setDate(today.getDate()+4)
    this.day = Number(this.myDate.getDate()) ;
    this.month = Number(this.myDate.getMonth() + 1)
    this.convertD = this.convert(this.day , this.month)[0]
    this.convertM = this.convert(this.day , this.month)[1]
    this.year = this.myDate.getFullYear();
    this.Day5 = this.convertM +" "+ this.convertD + " ,  " + this.year ;
  }
  getDay6()
  {
    var today = new Date() 
    this.myDate  = new Date(); 
    this.myDate.setDate(today.getDate()+5)
    this.day = Number(this.myDate.getDate()) ;
    this.month = Number(this.myDate.getMonth() + 1)
    this.convertD = this.convert(this.day , this.month)[0]
    this.convertM = this.convert(this.day , this.month)[1]
    this.year = this.myDate.getFullYear();
    this.Day6 = this.convertM +" "+ this.convertD + " ,  " + this.year ;
  }
  convert(day,month)
  {
    var convertDay , convertMonth 
    if(day < 10)
    {
      convertDay = "0"+day 
    }
    else 
    {
      convertDay = day 
    }

    if(month == 1 )
    {
      convertMonth = "Jan"
    }
    else if(month == 2 )
    {
      convertMonth = "Feb"
    }
    else if(month == 3 )
    {
      convertMonth = "Mar"
    }
    else if(month == 4 )
    {
      convertMonth = "Apr"
    }
    else if(month == 5 )
    {
      convertMonth = "May"
    }
    else if(month == 6 )
    {
      convertMonth = "Jun"
    }
    else if(month == 7 )
    {
      convertMonth = "Jul"
    }
    else if(month == 8 )
    {
      convertMonth = "Aug"
    }
    else if(month == 9 )
    {
      convertMonth = "Sept"
    }
    else if(month == 10 )
    {
      convertMonth = "Oct"
    }
    else if(month == 11 )
    {
      convertMonth = "Nov"
    }
    else
    {
      convertMonth = "Dec"
    }
    return [convertDay,convertMonth]
  }
  /************************************************************* */
goToDetails(id)
{
this._router.navigate(['/Movie/Details',id])

}
  /************************************************* */
changeSchedule(Day)
  {
    this._router.navigate(["/schedule",Day])
  }
/************************************************* */

getMovies()
{
  for(let item of this.GetDay)
    {
      for(let movie of this.movies.movies)
      {
        if(item.movieId === movie.id)
        {
          this.movieArray.push(movie) 
          break ;
        }
      }
    }
    console.log(this.movieArray)
}

}
